module.exports = __webpack_public_path__ + "static/media/epson-logo-9.b096822f.png";